// extracted by mini-css-extract-plugin
export default {"container":"templatemapping_container__3VsHc","formSelect":"templatemapping_formSelect__bebKh"};